import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ViewChild, OnDestroy, SimpleChanges } from '@angular/core';
import { DeviceService } from '../../device.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import * as moment from 'moment';
import { DeviceManagementService } from 'src/app/device/device-management.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from 'src/app/users/users.service';
import { Router } from '@angular/router';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ColumnsConfig, TableConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { mainDeviceConfig } from '../../device-factory/device-config';
import { IotahDevice } from '../../device-factory/Iotah-device';
import { DeviceFactory } from '../../device-factory/device-factory';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { DeviceTypeService } from '../../device-type.service';
import { SiteDashboardService } from '../../../site-dashboard.service';
import { Subscription } from 'rxjs';
import { SitesService } from 'src/app/sites/sites.service';
import { SiteTemperatureUnit } from '../../../site-settings/site-utilization-settings/site-utilization-settings.interface';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';

@Component({
	selector: 'app-rt',
	templateUrl: './rt.component.html',
	styleUrls: ['./rt.component.css']
})
export class RtComponent implements OnInit, OnChanges, OnDestroy {
	@ViewChild("fetchRtModal") fetchRtModal: ModalComponent;

	@Input() device: any = {};
	@Input() currentSite: any;
	@Input() dateRange: any = {};
	@Output() onDeviceDataChange = new EventEmitter<Object>();

	// table data
	tableData: TableData[] = [];
	tableConfig: TableConfig = {
		hasExport: true,
		hasPagination: true,
		pageSize: 100,
		draggable: false,
		fileName: this.translateService.instant('nav.rt_records'),
		csvFileHeaderInfo: []
	};

	columnConfig: ColumnsConfig[];

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		timestamp: TimeSource.Device,
	};

	deviceConfig: mainDeviceConfig | null = (new IotahDevice).config;

	fromDateFormatted;
	data: any[] = [];
	byId = true;

	rowData: any[] = [];

	visibilityCheckboxes: any = {
		voltage: true,
		current: true,
		kw: true,
	};
	chartObject: any = {};
	showChart: boolean = false;
	chartData: any = [];

	maxRTHours: number = 48;
	force_read_rt_time: number = null;
	forceReadRTUntil: string = '';

	fetchRtByIdLimit = 12000;
	fetchRtByTimeLimitSec = 36 * 60 *60;
	fetchRtBy: any = {
		id: {
			fromId: null,
			toId: null,
			error: ""
		},
		timeRange: {
			fromTime: '',
			toTime: '',
			fromTimeLocal: '',
			toTimeLocal: '',
			error: ""
		}
	}

	fetchRtRecordsByRangeErrorsCode = {
		1: "start_id_less_end_id",
		2: "start_id_not_exist",
		3: "end_id_not_exist",
		4: "fetch_rt_in_progress",
		5: 'range_already_exist',
		6: 'exceed_max_range_allowed',
		7: 'before_installation_date',
	}

	deviceTimeZoneText: string = '';

	isIMDeviceType = false;
	allColumnsKeys = [
		'sequence_id',
		'timestamp',
		'voltage',
		'current',
		'temperature',
		'version',
		'rt_flag_current_error',
	];

	readonly imAllColumnsKeys = [
		'sequence_id',
		'timestamp',
		'rt_log_frequency',
		'voltage_a',
		'voltage_b',
		'voltage_c',
		'current_a',
		'current_b',
		'current_c',
		'active_power_generated',
		'active_power_consumed',
		'va_t_kva_generated',
		'va_t_kva_consumed',
		'var_t_kvar_generated',
		'var_t_kvar_consumed',
		'watt_hr_t_kwh_generated',
		'watt_hr_t_kwh_consumed',
		'pf_a',
		'pf_b',
		'pf_c',
		'line_frequency_com',
		'modbus_cons_kwh',
		'modbus_gen_kwh',
		'runtime_warnings',
	];

	readonly voltageFields = [
		'voltage_a',
		'voltage_b',
		'voltage_c'
	];

	readonly integerFields = [
		'sequence_id',
	]

	readonly fieldsToBeRounded = [
		'modbus_cons_kwh',
		'modbus_gen_kwh',
	];

	readonly floatFields = [
		'voltage_a',
		'voltage_b',
		'voltage_c',
		'current_a',
		'current_b',
		'current_c',
		// 'active_power_consumed',
		// 'active_power_generated',
		'pf_a',
		'pf_b',
		'pf_c',
		// 'va_t_kva_consumed',
		// 'va_t_kva_generated',
		// 'var_t_kvar_consumed',
		// 'var_t_kvar_generated',
		// 'watt_hr_t_kwh_consumed',
		// 'watt_hr_t_kwh_generated',
		'line_frequency_com',
		'voltage_a_ll',
		'voltage_b_ll',
		'voltage_c_ll'
	];

	readonly dateTimeFields = [
		"timestamp",
	];

	readonly booleanFields = [
		'rt_flag_current_error',
		'rt_el_level_flag',
	];

	readonly absFields: string[] = [
		'voltage_a',
		'voltage_b',
		'voltage_c',
		'current_a',
		'current_b',
		'current_c',
		'v_thd_total',
		'i_thd_total',
		'voltage_a_ll',
		'voltage_b_ll',
		'voltage_c_ll'
	];

	readonly powerCols: string[] = [
		'active_power_generated',
		'active_power_consumed',
		'va_t_kva_generated',
		'va_t_kva_consumed',
		'var_t_kvar_generated',
		'var_t_kvar_consumed',
		'watt_hr_t_kwh_generated',
		'watt_hr_t_kwh_consumed',
	];

	readonly phaseColumns: Record<string, string[]> = {
		a: ['voltage_a', 'current_a', 'pf_a'],
		b: ['voltage_b', 'current_b', 'pf_b'],
		c: ['voltage_c', 'current_c', 'pf_c'],
	};

	readonly imFieldsNotIncludedToCharts = [
		'sequence_id',
		'timestamp',
		'rt_log_frequency',
		'version',
	];

	readonly imFieldsToBeShowByDefault = [
		'voltage_a',
		'voltage_b',
		'voltage_c',
		'current_a',
		'current_b',
		'current_c',
		'active_power_generated',
		'active_power_consumed',
	];

	imChartObject: any = {};
	showImChart: boolean = false;
	imChartFields: string[] = [];
	imVisibleFields: Record<string, boolean> = {};

	permissionsSub: Subscription = new Subscription();
	getRTSub: Subscription = new Subscription();
	getDailyRtSub: Subscription = new Subscription();

	dailyRtData: any = [];

	showTempChart: boolean = false;
	highTemperatureLimit: number;
	temperatureUnit: number = SiteTemperatureUnit.FAHRENHEIT;
	tempChartObject: any = { data: [], columnNames: [], config: {} };

	showSocChart: boolean = false;
	show20PercentLine: boolean = true;
	show80PercentLine: boolean = true;
	socChartObject: any = { data: [], columnNames: [], config: {} };
	percentValueOf20 = 20;
	percentValueOf80 = 80;

	rtChartDefaultConfig = {
		LegendPosition: 'top',
		hAxis: {
			title: "Time of Day",
		},
		chartArea: {
			width: '80%',
			height: '70%',
			backgroundColor: {
				stroke: '#000',
				strokeWidth: 2,
			}
		},
		explorer: {
			"actions": [
				"dragToZoom",
				"rightClickToReset",
			],
			maxZoomIn: 50.0,
			keepInBounds: true
		},
		widgetHeight: 400,
		dataIsDataTable: true,
	};

	get rtPeriodPrintFilters(): { label: string, value: string }[] {
		return [
			{ label: 'perf_analytic.period', value: this.fromDateFormatted }
		];
	}

	get voltageAndCurrentPrintFilters(): { label: string, value: string }[] {
		return [
			...this.rtPeriodPrintFilters,
			{ label: 'fleet_reports.show_voltage', value: this.translateService.instant(this.visibilityCheckboxes.voltage ? 'g.yes' : 'g.no') },
			{ label: 'fleet_reports.show_current', value: this.translateService.instant(this.visibilityCheckboxes.current ? 'g.yes' : 'g.no') },
			...(this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw') ?
				[{ label: 'g.show_kw', value: this.translateService.instant(this.visibilityCheckboxes.kw ? 'g.yes' : 'g.no') }] : [])
		];
	}

	get socPrintFilters(): { label: string, value: string }[] {
		return [
			...this.rtPeriodPrintFilters,
			{ label: 'studies.soc_20', value: this.translateService.instant(this.show20PercentLine ? 'g.yes' : 'g.no') },
			{ label: 'studies.soc_80', value: this.translateService.instant(this.show80PercentLine ? 'g.yes' : 'g.no') }
		];
	}

	// The temperature chart had no print-filters block at all - the sibling voltage/current and
	// SOC sections above already carry one, this one was simply missed.
	get tempPrintFilters(): { label: string, value: string }[] {
		return [...this.rtPeriodPrintFilters];
	}

	constructor(
		public deviceService: DeviceService,
		public commonService: CommonService,
		private deviceManagementService: DeviceManagementService,
		private notificationMessage: NotificationMessageService,
		private translateService: TranslateService,
		public usersService: UsersService,
		private router: Router,
		private domainsService: DomainsService,
		private deviceTypeService: DeviceTypeService,
		private siteDashboardService: SiteDashboardService,
		private siteService: SitesService,
	) { }

	public ngOnInit() {
		this.permissionsSub = this.siteDashboardService.permissionsOfCurrentSite.subscribe(data=> {
			if (!this.usersService.hasAccessPermission(data, 'read_rts'))
				return this.router.navigate(['/unauthorized']);

			this.isIMDeviceType = DeviceFactory.isIMDeviceType(this.device.config_info.sct_device_type);
			if (this.isIMDeviceType) {
				this.allColumnsKeys = this.imAllColumnsKeys;
				this.initImChartFields();
			} else {
				// Hide temperature field for ChargLink (type 1) and BRM (type 3) devices
				const deviceType = this.device.config_info.sct_device_type;
				const isChargLinkOrBRM = deviceType === DeviceFactory.types.charglink || deviceType === DeviceFactory.types.brm;
				
				if (isChargLinkOrBRM) {
					this.allColumnsKeys = [
						'sequence_id',
						'timestamp',
						'voltage',
						'current',
						'version',
						'rt_flag_current_error',
					];
				}
			}

			this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - RT Records`);
			if(this.domainsService.isDevelopmentDomain)
				this.tableConfig.pageSize = 5;

			this.chartObject.formatterType = 'DateFormat';
			this.chartObject.formatter = {pattern: "MM/dd/yyyy HH:mm:ss"};
			this.getRTDate();

			this.deviceTimeZoneText = this.commonService.getZoneName(this.device.config_info.zone_id).match(/\((UTC.*?)\)/)[0];
			this.deviceConfig = DeviceFactory.createDevice(this.device.config_info.sct_device_type).config;
			
			if (this.isIMDeviceType)
				this.prepareImRTColumnConfig();
			else
				this.prepareRTColumnConfig();

			this.tableConfig.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.currentSite.customer_name,
				siteName: this.currentSite.name,
				deviceSN: this.device.serial_number,
				includeSpacing: false
			});
		});
	}

	ngAfterViewInit(): void {
		this.fetchRtModal.onClose.subscribe((result: any) => {
			let by: 'id' | 'timeRange' = 'timeRange';

			if (this.byId)
				by = 'id';

			this.fetchRtBy[by].error= "";

			if(result) {
				if(!this.validateRange(by))
					return;

				this.fetchRtRecordsByRange(by);
			}

			this.fetchRtModal.hide();
			this.fetchRtBy[by] = by == 'id' ? {fromId: null, toId: null, error: ''} : {fromTime: '', fromTimeLocal: '', toTimeLocal: '', toTime: '', error: ''};
			return;
		});
	}

	prepareRTColumnConfig() {
		const columns: any = [
			{ key: 'sequence_id', name: this.translateService.instant('rt.sequence_id'), type: "number"},
			{ key: 'timestamp', name: this.translateService.instant('rt.timestamp'), type: "date"},
			{ key: 'voltage', name: this.translateService.instant('rt.voltage'), type: 'number'},
			{ key: 'current', name: this.translateService.instant('rt.current'), type: 'number'},
		];

		// Hide temperature field for ChargLink (type 1) and BRM (type 3) devices
		const deviceType = this.device.config_info.sct_device_type;
		const isChargLinkOrBRM = deviceType === DeviceFactory.types.charglink || deviceType === DeviceFactory.types.brm;
		
		if (!isChargLinkOrBRM) {
			columns.push({ key: 'temperature', name: `${this.translateService.instant('rt.temperature')} (${this.commonService.tempUnitSymbol(this.temperatureUnit)})`, type: 'number', hidden: true});
		}

		columns.push(
			{ key: 'version', name: this.translateService.instant('rt.version'), type: 'number', hidden: true},
			{ key: 'rt_flag_current_error', name: this.translateService.instant('rt.rt_flag_current_error'), type: 'boolean'}
		);

		if (this.deviceConfig.fields.hasWaterLevel && this.device.config_info.has_water_level)
			columns.push({ key: 'rt_el_level_flag', name: this.translateService.instant('rt.rt_el_level_flag'), type: 'boolean', filterTrueText: this.translateService.instant('g.high'), filterFalseText: this.translateService.instant('g.low')});

		if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw'))
			columns.push({ key: 'kw', name: this.translateService.instant('g.power_kw'), type: 'number' });

		if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_soc') && (this.deviceConfig.isBattlink || this.deviceTypeService.isStudyDevice(this.device.config_info)))
			columns.push({ key: 'soc', name: this.translateService.instant('g.soc'), type: 'number' });

		this.columnConfig = this.filterColumns(columns);
		this.commonService.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);
	}

	filterColumns(columns: any[]): any[] {

		let filterFields = [];
		if (this.deviceConfig.fields.hasTemperatureSensor === false)
			filterFields.push('temperature');

		return columns.filter(col => !filterFields.includes(col.key));
	}

	prepareImRTColumnConfig() {
		let columns = [];
		for (let field of this.allColumnsKeys) {
			if (!this.usersService.hasAccessPermission(null, `rt.${field}`, 'read', null, DeviceFactory.typesString.ioTEmeterSp3))
				continue;

			if (!(this.device.config_info.enabled_wires & 0x1) && this.phaseColumns.a.includes(field))
				continue;

			if (!(this.device.config_info.enabled_wires & 0x2) && this.phaseColumns.b.includes(field))
				continue;

			if (!(this.device.config_info.enabled_wires & 0x4) && this.phaseColumns.c.includes(field))
				continue;

			let suffix = '';
			if (this.device?.config_info?.voltage_reference === this.deviceService.lineToLine && this.voltageFields.includes(field))
				suffix += '_ll';

			let columnConfig: ColumnsConfig = { key: field, name: this.translateService.instant('rt.'+field+suffix), type: 'string' };
			if (this.integerFields.includes(field) || this.floatFields.includes(field)) {
				columnConfig.type = 'number';
				columnConfig.noValueString = 'N/A';
			} else if (this.dateTimeFields.includes(field)) {
				columnConfig.type = 'date';
			}

			columns.push(columnConfig);
		}

		this.columnConfig = columns;
		this.commonService.applyTimeSourceTooltips(this.columnConfig, this.timeSourceByColumn);
	}

	validateRange(by) {
		let isValid = true;
		let errors = [];
		const messagesMapper = {
			fill_all_fields: 'force_read_rt',
			start_date_before_end_date: "g",
			exceed_max_time_range_allowed: "force_read_rt"
		}

		switch (by) {
			case 'id':
				if (this.fetchRtBy.id.fromId == null || this.fetchRtBy.id.toId == null)
					errors.push('fill_all_fields');

				if (this.fetchRtBy.id.fromId < 0 || this.fetchRtBy?.id.toId < 0)
					errors.push('ids_should_be_positive');

				if (this.fetchRtBy.id.fromId > this.fetchRtBy.id.toId)
					errors.push('start_id_should_be_less_than_end_id');

				if (this.fetchRtBy.id.toId - this.fetchRtBy.id.fromId > this.fetchRtByIdLimit)
					errors.push('exceed_max_range_allowed');

				if (errors.length) {
					isValid = false;
					this.fetchRtBy.id.error = errors.map(error => this.translateService.instant(`force_read_rt.${error}`)).join(', ');
				}
				break;

			case 'timeRange':
				const fromTime = this.fetchRtBy.timeRange.fromTime ? moment(this.fetchRtBy.timeRange.fromTime).unix() : null;
				const toTime = this.fetchRtBy.timeRange.toTime ? moment(this.fetchRtBy.timeRange.toTime).unix() : null;

				if (!fromTime || !toTime)
					errors.push('fill_all_fields');

				if (fromTime > toTime)
					errors.push('start_date_before_end_date');

				if (toTime - fromTime > this.fetchRtByTimeLimitSec)
					errors.push('exceed_max_time_range_allowed');

				if (errors.length) {
					isValid = false;
					this.fetchRtBy.timeRange.error = errors.map(error => this.translateService.instant(`${messagesMapper[error]}.${error}`)).join(', ');
				}
				break;

			default:
				break;
		}

		return isValid;
	}

	openFetchRTPopup(byId) {
		this.byId = byId;
		this.fetchRtModal.show();
	}

	formatTime(field, value: string) {
		this.fetchRtBy.timeRange[field] = moment(value).format('YYYY/MM/DD HH:mm:ss');
	}

	fetchRtRecordsByRange(type: 'timeRange' | 'id') {
		const range: any = {};

		switch (type) {
			case 'timeRange':
				range.fromTime = this.fetchRtBy.timeRange.fromTime;
				range.toTime = this.fetchRtBy.timeRange.toTime;
				break;

			case 'id':
				range.fromId = this.fetchRtBy.id.fromId;
				range.toId = this.fetchRtBy.id.toId;
				break;

			default:
				break;
		}

		this.deviceService.fetchRtRecordsByRange(this.device.mac_address, range).subscribe((data: any) => {
			if (data.err) {
				const errorText = this.fetchRtRecordsByRangeErrorsCode[data.err];

				if (errorText)
					return this.notificationMessage.setMessage(this.translateService.instant(`force_read_rt.${errorText}`));

				return this.notificationMessage.setMessage(this.translateService.instant(`g.global_err`));
			}

			this.notificationMessage.setMessage('globalSuccessMsg', {clearOnXTimeNavigate: 1})
		});
	}

	getData() {
		let fromDateRange = this.dateRange.fromDate;
		this.fromDateFormatted = moment(this.dateRange.fromDate).format('MM/DD/YYYY');

		if(!this.device.mac_address || !fromDateRange)
			return;

		let zoneDiff		= new Date().getTimezoneOffset() * -1;
		let fromDate:any	= new Date(new Date(fromDateRange).getTime() + (zoneDiff * 60 * 1000));
		fromDate			= moment(fromDate).utc().startOf('day').unix();
		fromDate			= this.commonService.getUTCTimestampFromZone((this.device.config_info.zone_id?this.device.config_info.zone_id:this.currentSite.zone_id), fromDate);

		this.getRTSub = this.deviceService.getRTs(this.device.mac_address, fromDate).subscribe((data: any) => {
			this.formatData(data);
			this.tableData = this.fillRtTablesData(this.data);
			if (this.isIMDeviceType)
				this.drawImRTrecordsChart();
			else
				this.drawRTrecordsChart();
		});
	}

	formatData(data) {
		this.chartData = [];
		let events = [];
		data.forEach((element) => {
			let record = this.commonService.decompress(element, 'rt', this.device.config_info.sct_device_type);
			if(!record.rt_flag_current_error)
				record.rt_flag_current_error = 0;

			if (!record.rt_el_level_flag)
				record.rt_el_level_flag = 0;
			
			this.chartData.push({...record});

			this.formatRt(record);
			events.push(record);
		});

		this.data = events;
	}

	formatRt(rt: any) {
		const rtKeys = Object.keys(rt);
		for (const field of rtKeys) {
			switch (true) {
				case this.booleanFields.includes(field):
					rt[field] = !!rt[field];
					break;
				case this.absFields.includes(field):
					rt[field] = Math.abs(rt[field]);
					break;
				case this.powerCols.includes(field) && rt[field] === null:
					rt[field] = this.translateService.instant('g.n/a');
					break;
				case this.powerCols.includes(field) && rt[field] === 0:
					rt[field] = this.translateService.instant('0.00');
					break;
				case (this.powerCols.includes(field) || this.fieldsToBeRounded.includes(field)) && typeof rt[field] === 'number':
					rt[field] = rt[field].toFixed(2);
					break;
				case this.dateTimeFields.includes(field):
					rt[field] = this.commonService.getZoneTimestampFromUTC((this.device.config_info.zone_id?this.device.config_info.zone_id:this.currentSite.zone_id), rt[field]);
					rt[field] = moment(rt[field]*1000).utc().format('MM/DD/YYYY HH:mm:ss');
					break;
				default:
					break;
			}

			if (this.floatFields.includes(field)) {
				rt[field] = (rt[field] / 1.0).toFixed(2);
				if (Number.isNaN(rt[field]))
					rt[field] = 0.00;
			}
		}

		if (this.device?.config_info?.voltage_reference === this.deviceService.lineToLine) {
			for (const key of this.voltageFields)
				rt[key] = rt[key + '_ll'];
		}

		const warnings = this.deviceService.mapRunTimeWarning(rt['runtime_warnings']);
		rt['runtime_warnings'] = warnings.length ? warnings.map((warning) => this.translateService.instant('warnings.'+ warning)).join(', '): '-';

		rt['rt_log_frequency'] = this.deviceService.formatRtLogFrequencyField(this.device.config_info, rt['rt_log_frequency'], true);
	}

	fillRtTablesData(data: any[]): TableData[] {
		if (!data || !data.length)
			return [];

		const tableData: TableData[] = [];
		for (let rt of data) {
			const tableRtData = {};
			for (let field of this.allColumnsKeys) {
				tableRtData[field] = { value: rt[field] };
			}

			if (rt['temperature'] !== undefined && rt['temperature'] !== null)
				tableRtData['temperature'] = { value: this.commonService.formatSensorTemp(rt['temperature'], this.temperatureUnit) };

			
			if (this.deviceConfig.fields.hasWaterLevel && this.device.config_info.has_water_level)
				tableRtData['rt_el_level_flag'] = { value: rt.rt_el_level_flag, trueText: this.translateService.instant('g.high'), falseText: this.translateService.instant('g.low') };

			if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw'))
				tableRtData['kw'] = { value: rt.kw };

			if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_soc') && (this.deviceConfig.isBattlink || this.deviceTypeService.isStudyDevice(this.device.config_info)))
				tableRtData['soc'] = { value: rt.soc };

			tableData.push(tableRtData);
		}

		return tableData;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.device?.currentValue != changes.device?.previousValue) {
			this.deviceConfig = DeviceFactory.createDevice(this.device.config_info.sct_device_type).config;
			this.prepareRTColumnConfig();
			this.getSiteUtilizationSettings();
		}

		this.getData();

		if (DeviceFactory.isBattlinkDeviceType(this.device.config_info.sct_device_type))
			this.getDailyRt();
	}

	getSiteUtilizationSettings() {
		this.siteService.getSiteUtilizationSettings(this.device.config_info.site_id).subscribe((res: any) => {
			const siteUtilizationSettings = res?.[0];
			if (!siteUtilizationSettings)
				return;

			const batteriesSettings = siteUtilizationSettings.batteries_utilization_settings;
			this.temperatureUnit = batteriesSettings.temperature_unit ?? SiteTemperatureUnit.FAHRENHEIT;

			if (siteUtilizationSettings.batteries_utilization_settings.temperature_unit == SiteTemperatureUnit.CELSIUS)
				this.highTemperatureLimit = this.commonService.fahToCel(siteUtilizationSettings.batteries_utilization_settings.high_temperature_limit);
			else
				this.highTemperatureLimit = siteUtilizationSettings.batteries_utilization_settings.high_temperature_limit;

			if (this.isIMDeviceType)
				this.prepareImRTColumnConfig();
			else
				this.prepareRTColumnConfig();

			if (this.data?.length)
				this.tableData = this.fillRtTablesData(this.data);
			this.drawTempChart();
		});
	}

	drawRTrecordsChart() {
		this.showChart = false;
		if (this.chartData.length === 0)
			return;

		if(!this.chartData[0].hasOwnProperty('voltage') && !this.chartData[0].hasOwnProperty('current'))
			return;

		let vAxes = {
			"0" : {
				"textPosition": "out",
					textStyle: {color: '#328332'},
					title: "Voltage (V)",
					titleTextStyle: {color: '#328332'},
				},
			"1" : {
				"textPosition": "in",
				textStyle:{color: '#2828ab'},
				title: "Current (A)",
				titleTextStyle: {color: '#2828ab'}
			}
		};
		let series: any = {
			"0" : {
				"targetAxisIndex":0,
				"color": "#328332" ,
				type: 'line'
			},
			"1" : {
				"targetAxisIndex":1,
				"color" : "#2828ab",
				type: 'line'
			},
			"2": {
				"targetAxisIndex":2,
				"color" : "#FFA500",
				type: 'line'
			},
			"3": {
				"targetAxisIndex": 2,
				"color" : "#0cedf0",
				type: 'line'
			}
		};

		if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw'))
			series["4"] = { "color" : "#ff0000", type: 'line' };

		let config = {
			LegendPosition: 'top',
			hAxis: {
				title: "Time of Day"
			},
			chartArea: {
				width: '80%',
				height: '70%',
				backgroundColor: {
					stroke: '#000',
					strokeWidth: 2
				}
			},
			vAxes: vAxes,
			"series": series,
			explorer: {
				"actions": [
					"dragToZoom",
					"rightClickToReset"
				],
				maxZoomIn: 50.0,
				keepInBounds: true
			},
			widgetHeight: 400,
			dataIsDataTable: true,
		};

		if (!this.visibilityCheckboxes.voltage) {
			config.series["0"].lineWidth = 0;
			config.series["0"].enableInteractivity= false;
			config.series["0"].tooltip ="none";
			config.vAxes["0"].textPosition = "none";
			config.vAxes["0"].title = "";
		}
		if (!this.visibilityCheckboxes.current) {
			config.series["1"].lineWidth = 0;
			config.series["1"].enableInteractivity= false;
			config.series["1"].tooltip ="none";
			config.vAxes["1"].textPosition = "none";
			config.vAxes["1"].title = "";
		}

		if (!this.visibilityCheckboxes.kw) {
			config.series["4"].lineWidth = 0;
			config.series["4"].enableInteractivity= false;
			config.series["4"].tooltip ="none";
		}

		this.chartObject.columnNames = ['Date', 'Voltage', 'Current', 'Current Reset'];

		if (this.deviceConfig.fields.hasWaterLevel && this.device.config_info.has_water_level)
			this.chartObject.columnNames.push(this.translateService.instant('rt.rt_el_level_flag'));

		if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw'))
			this.chartObject.columnNames.push(this.translateService.instant('g.power_kw'));

		let data		= [];
		let zoneDiff	= new Date().getTimezoneOffset() * -1;

		this.chartData.forEach((item) => {
			let timestamp = this.commonService.getZoneTimestampFromUTC((this.device.config_info.zone_id?this.device.config_info.zone_id:this.currentSite.zone_id), item.timestamp);
			timestamp = new Date(new Date(timestamp*1000).getTime() - (zoneDiff * 60 * 1000));

			const rtData = [timestamp, item.voltage, item.current, item.rt_flag_current_error];
			if (this.deviceConfig.fields.hasWaterLevel && this.device.config_info.has_water_level)
				rtData.push(item.rt_el_level_flag);

			if (this.deviceService.isFWSupportedFeature(this.device.config_info.fw_version, 'disable_rt_kw'))
				rtData.push(item.kw);

			data.push(rtData);
		});

		let rtSorter =  function(a, b) {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		}

		this.chartObject.data = data.sort(rtSorter);
		this.chartObject.config = config;

		if (data.length > 1)
			this.showChart = true;
	}

	generateDatasetColor(generatedColors: string[]): string {
		const letters = '0123456789ABCDEF';
		let color: string;
		do {
			color = '#';
			for (let i = 0; i < 6; i++)
				color += letters[Math.floor(Math.random() * 16)];
		} while (generatedColors.includes(color));
		generatedColors.push(color);
		return color;
	}

	initImChartFields() {
		this.imChartFields = [];
		this.imVisibleFields = {};
		for (const field of this.imAllColumnsKeys) {
			if (this.imFieldsNotIncludedToCharts.includes(field))
				continue;

			if (!this.usersService.hasAccessPermission(null, `rt.${field}`, 'read', null, DeviceFactory.typesString.ioTEmeterSp3))
				continue;

			this.imChartFields.push(field);
			this.imVisibleFields[field] = this.imFieldsToBeShowByDefault.includes(field);
		}
	}

	getImFieldLabel(field: string): string {
		let suffix = '';
		if (this.device?.config_info?.voltage_reference === this.deviceService.lineToLine && this.voltageFields.includes(field))
			suffix = '_ll';
		return this.translateService.instant('rt.' + field + suffix);
	}

	drawImRTrecordsChart() {
		this.showImChart = false;
		if (this.chartData.length === 0)
			return;

		const zoneId = this.device.config_info.zone_id || this.currentSite.zone_id;
		const zoneDiff = new Date().getTimezoneOffset() * -1;

		// Filter to only visible fields
		const visibleFields = this.imChartFields.filter(f => this.imVisibleFields[f]);
		if (visibleFields.length === 0)
			return;

		// Build column names
		const columnNames = ['Date'];
		const series: any = {};
		const colors: string[] = [];

		visibleFields.forEach((field, index) => {
			columnNames.push(this.getImFieldLabel(field));
			const color = this.generateDatasetColor(colors);
			series[index] = { color, type: 'line' };
		});

		// Build data rows with only visible fields
		const data = [];
		this.chartData.forEach((item: any) => {
			let timestamp = this.commonService.getZoneTimestampFromUTC(zoneId, item.timestamp);
			timestamp = new Date(new Date(timestamp * 1000).getTime() - (zoneDiff * 60 * 1000));

			const row: any[] = [timestamp];
			for (const field of visibleFields) {
				let chartField = field;
				if (this.device?.config_info?.voltage_reference === this.deviceService.lineToLine && this.voltageFields.includes(field))
					chartField = field + '_ll';

				const value = item[chartField];
				row.push(typeof value === 'number' ? parseFloat(value.toFixed(2)) : 0);
			}
			data.push(row);
		});

		data.sort((a, b) => {
			if (a[0] < b[0]) return -1;
			if (a[0] > b[0]) return 1;
			return 0;
		});

		// Downsample to avoid rendering performance issues with large datasets
		const chartData = this.downsampleChartData(data);

		this.imChartObject.formatterType = 'DateFormat';
		this.imChartObject.formatter = { pattern: 'MM/dd/yyyy HH:mm:ss' };
		this.imChartObject.columnNames = columnNames;
		this.imChartObject.data = chartData;
		this.imChartObject.config = {
			legend: { position: 'top', maxLines: 5 },
			hAxis: { title: 'Time of Day' },
			chartArea: {
				left: '10%',
				right: '10%',
				width: '80%',
				height: '65%',
				backgroundColor: { stroke: '#000', strokeWidth: 2 }
			},
			series,
			explorer: {
				actions: ['dragToZoom', 'rightClickToReset'],
				maxZoomIn: 50.0,
				keepInBounds: true
			},
			widgetHeight: 400,
			dataIsDataTable: true,
		};

		if (chartData.length > 1)
			this.showImChart = true;
	}

	/**
	 * Downsample data array to maxPoints to prevent Google Charts SVG rendering
	 * from freezing the browser with large datasets. Uses uniform sampling with
	 * min/max preservation per bucket to retain peaks and valleys.
	 */
	readonly chartMaxPoints = 500;

	downsampleChartData(data: any[]): any[] {
		if (data.length <= this.chartMaxPoints)
			return data;

		const numCols = data[0].length;
		const result: any[] = [];
		const bucketSize = (data.length - 2) / (this.chartMaxPoints - 2);

		// Always keep the first point
		result.push(data[0]);

		for (let i = 0; i < this.chartMaxPoints - 2; i++) {
			const start = Math.floor(i * bucketSize) + 1;
			const end = Math.min(Math.floor((i + 1) * bucketSize) + 1, data.length - 1);
			const bucketLen = end - start;

			if (bucketLen <= 0) {
				if (start < data.length - 1)
					result.push(data[start]);
				continue;
			}

			// Compute per-column average within this bucket
			const colAvg = new Array(numCols).fill(0);
			for (let j = start; j < end; j++) {
				for (let col = 1; col < numCols; col++)
					colAvg[col] += (data[j][col] || 0);
			}
			for (let col = 1; col < numCols; col++)
				colAvg[col] /= bucketLen;

			// Pick the point with the largest deviation from the bucket average
			// across all numeric columns — this preserves peaks and valleys
			// regardless of each column's typical magnitude
			let bestIdx = start;
			let bestScore = -1;

			for (let j = start; j < end; j++) {
				let score = 0;
				for (let col = 1; col < numCols; col++)
					score += Math.abs((data[j][col] || 0) - colAvg[col]);

				if (score > bestScore) {
					bestScore = score;
					bestIdx = j;
				}
			}

			result.push(data[bestIdx]);
		}

		// Always keep the last point
		result.push(data[data.length - 1]);

		return result;
	}

	getRTDate(force_read_rt_time?) {
		force_read_rt_time = force_read_rt_time || this.device.config_info.force_read_rt_time;
		if(force_read_rt_time && typeof(force_read_rt_time) == 'number')
			this.forceReadRTUntil = moment.unix(force_read_rt_time || 0).utc().format('MM/DD/YYYY H:mm');
	}

	saveRTDate() {
		if(this.force_read_rt_time > this.maxRTHours || this.force_read_rt_time < 0)
			return this.notificationMessage.setMessage(this.translateService.instant('force_read_debug.select_time_more_max_time'));

		this.deviceManagementService.setForceReadRTDate(this.device.mac_address, this.force_read_rt_time).subscribe((data: any) => {
			if(data.api_status == 3)
				return this.notificationMessage.setMessage('translate|rt_requests.force_read_rt_validation_msg', {clearOnXTimeNavigate: 1});
			this.onDeviceDataChange.emit(data);
			this.getRTDate(data.force_read_rt_time);
			this.notificationMessage.setMessage('globalSuccessMsg', {clearOnXTimeNavigate: 1});
		})
	}

	getDailyRt() {
		let zoneDiff = new Date().getTimezoneOffset() * -1;

		const rtFromDate = new Date(new Date(this.dateRange.fromDate).setHours(0, 0, 0, 0));
		const rtToDate = new Date(new Date(this.dateRange.fromDate).setHours(23, 59, 59, 999));

		let fromDate: any = new Date(new Date(rtFromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate: any = new Date(new Date(rtToDate).getTime() + (zoneDiff * 60 * 1000));

		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		const battlinkTypes = [
			DeviceFactory.types.battlink,
			DeviceFactory.types.lithiumBattlink,
			DeviceFactory.types.battlinkII,
		];

		this.getDailyRtSub = this.siteService.getDailyRtData(fromDate, toDate, this.device.mac_address, battlinkTypes, 0, 0, {}).subscribe((res: any) => {
			this.dailyRtData = res.data || {};

			if (this.commonService.isFWSupportField('disable_soc', this.device.config_info.fw_version))
				this.drawSocChart();

			if (this.deviceConfig.fields.hasTemperatureSensor && this.device.config_info.sct_device_type != DeviceFactory.types.lithiumBattlink)
				this.drawTempChart();
		});
	}

	drawTempChart() {
		this.showTempChart = false;
		if (!Object.keys(this.dailyRtData).length)
			return;

		const maxTempLimit = Number(this.highTemperatureLimit || 130);
		const tempUnitSymbol = this.commonService.tempUnitSymbol(this.temperatureUnit);

		let config = {
			...this.rtChartDefaultConfig,
			legend: { position: 'top', alignment: 'right' },
			title: this.translateService.instant('exception_reports.battery_temperature'),
			vAxis: { title: `${this.translateService.instant('exception_reports.battery_temperature')} (${tempUnitSymbol})`, titleTextStyle: { color: '#FFA500' } },
			series: {
				0: { color: '#FFA500', type: 'line' },
				1: { color: '#FF0000', type: 'line', lineDashStyle: [4, 4], lineWidth: 2 },
			}
		};

		this.tempChartObject.columnNames = ['Date', `Temperature (${tempUnitSymbol})`, `Max Temperature Limit (${tempUnitSymbol})`];
		let data = [];

		for (let time in this.dailyRtData) {
			data.push([
				new Date(new Date(+time * 1000).getTime() - (new Date().getTimezoneOffset() * -1 * 60 * 1000)),
				Math.round(this.dailyRtData[time].temp || 0),
				maxTempLimit
			]);
		}

		this.tempChartObject.data = data.sort((a, b) => a[0] - b[0]);
		this.tempChartObject.config = config;

		if (data.length > 1)
			this.showTempChart = true;
	}

	drawSocChart() {
		this.showSocChart = false;
		if (!this.dailyRtData || !Object.keys(this.dailyRtData).length)
			return;

		let minSocLimit = 1000000;
		for (let time in this.dailyRtData) {
			const soc = Math.round(this.dailyRtData[time].soc);

			if (soc < minSocLimit)
				minSocLimit = soc;
		}

		const columnNames: string[] = ['Date', 'SOC', 'Minimum Battery SOC'];
		const series: any = {
			0: { color: '#28a745', lineWidth: 2 },
			1: {
				color: '#FFA500',
				lineWidth: 2,
				lineDashStyle: [4, 4],
				visibleInLegend: true,
			},
		};

		let seriesIndex = 2;

		if (this.show20PercentLine) {
			columnNames.push('20% Threshold');
			series[seriesIndex++] = {
				visibleInLegend: false,
				color: '#FF0000',
				lineDashStyle: [6, 4],
				enableInteractivity: false,
			};
		}

		if (this.show80PercentLine) {
			columnNames.push('80% Threshold');
			series[seriesIndex++] = {
				visibleInLegend: false,
				color: '#00AA00',
				lineDashStyle: [6, 4],
				enableInteractivity: false,
			};
		}

		let data = [];
		for (let time in this.dailyRtData) {
			const row: any[] = [
				new Date(new Date(+time * 1000).getTime() - (new Date().getTimezoneOffset() * -1 * 60 * 1000)),
				Math.round(this.dailyRtData[time].soc),
				minSocLimit,
			];

			if (this.show20PercentLine)
				row.push(this.percentValueOf20);
			if (this.show80PercentLine)
				row.push(this.percentValueOf80);

			data.push(row);
		}

		this.socChartObject.columnNames = columnNames;
		this.socChartObject.data = data.sort((a, b) => a[0] - b[0]);
		this.socChartObject.config = {
			...this.rtChartDefaultConfig,
			title: this.translateService.instant('exception_reports.battery_%_soc'),
			legend: { position: 'top', alignment: 'right' },
			vAxis: { title: 'Percentage (%)', titleTextStyle: { color: '#28a745' } },
			series: series,
		};

		if (data.length > 1)
			this.showSocChart = true;
	}

	exportRtChartData(chartData: any[] | undefined, valueColumnKey: string, title: string) {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
			customerName: this.currentSite.customer_name,
			siteName: this.currentSite.name,
			deviceSN: this.device.serial_number
		});

		const columns = [
			this.translateService.instant('g.time'),
			this.translateService.instant(valueColumnKey)
		];

		const data = (chartData || []).map(item => ([
			moment(item[0]).format('MM/DD/YYYY HH:mm:ss'),
			item[1]
		]));

		const dataObj = [...csvFileHeaderInfo, columns, ...data];
		const fileName = this.translateService.instant(this.translateService.instant(title));

		new AngularCsv(dataObj, fileName);
	}

	ngOnDestroy() {
		this.permissionsSub.unsubscribe();
		this.getRTSub?.unsubscribe();
		this.getDailyRtSub?.unsubscribe();
	}
}
